import { useEffect, useState } from 'react';
import {
  Control,
  UseFormRegister,
  UseFormResetField,
  UseFormSetValue,
} from 'react-hook-form';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Circle,
  HStack,
  MenuSearchBoxOption,
  Text,
} from '@cdl/heartbeat-react';
import { DropdownSingleData } from './dropdown/DropdownSingleData';
import { FormValues } from '../../types/annotation-task-detail.type';
import { getAllProject } from '../../clients/annotation-task.client';
import { ClearButton } from './ClearButton';

type Props = {
  register: UseFormRegister<FormValues>;
  setValue: UseFormSetValue<FormValues>;
  resetField: UseFormResetField<FormValues>;
  control: Control<FormValues>;
};

export const ProjectForm: React.FC<Props> = ({
  register,
  setValue,
  resetField,
  control,
}) => {
  const [selectedProjectLabel, setSelectedProjectLabel] = useState<string>();
  const [projectOptions, setProjectOptions] = useState<MenuSearchBoxOption[]>(
    [],
  );

  useEffect(() => {
    const fetchProjects = async () => {
      const projects = await getAllProject();
      setProjectOptions(projects);
    };
    fetchProjects();
  }, []);

  const handleProjectChange = (value: string) => {
    const display = projectOptions.find(
      (project) => project.value === value,
    )?.displayValue;
    setSelectedProjectLabel(`${display}`);
    setValue('project_id', value);
  };

  const clearAllData = () => {
    setSelectedProjectLabel('');
    resetField('project_id');
  };

  return (
    <Accordion defaultIndex={[0]} allowMultiple>
      <AccordionItem bgColor='white'>
        <AccordionButton
          justifyContent='space-between'
          p='l'
          borderBottom='1px'
          borderColor='neutral.100'
        >
          <HStack gap={2}>
            <Circle size='16px' m='s' border='1px' />
            <Text textStyle='page-subtitle'>Project</Text>
            <Text pl='xl' color='neutral.300'>
              {selectedProjectLabel ? selectedProjectLabel : 'No project set'}
            </Text>
          </HStack>
          <AccordionIcon />
        </AccordionButton>
        <AccordionPanel p='xl'>
          <DropdownSingleData
            options={projectOptions}
            handleDataChange={handleProjectChange}
            register={register}
            type='project_id'
            control={control}
          />
          <ClearButton clearAllData={clearAllData} />
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};
